import {
  field_background_theme,
  field_border_color,
  field_border_theme,
} from 'framework/field/constants';
import { font_dark_theme, font_theme } from 'framework/theme/constants/font';

import { colors } from '../../theme/constants/colors';
import { GridTheme } from '../types';

export const grid_theme = {
  general: {
    border_radius: '4px',
  },
  header: {
    padding: '0px 8px',
  },
  cell: {
    padding: '0px',
  },
  summary: {
    padding: '0px',
  },
};

export const grid_dark_theme: GridTheme = {
  general: {
    font_family: font_theme.general.font_family,
    font_size_normal: font_theme.general.font_size_normal,
    outline: field_border_theme.normal,
    border_radius: '4px',
  },
  color: {
    normal: font_dark_theme.color.normal,
    hover: font_dark_theme.color.hover,
    focus: font_dark_theme.color.focus,
    active: font_dark_theme.color.active,
  },
  header: {
    background: field_background_theme.normal,
    border_color: field_border_color,
    padding: '0px 8px',
  },
  cell: {
    background: field_background_theme.normal,
    border_color: field_border_color,
    padding: '0px',
  },
  summary: {
    background: field_background_theme.normal,
    border_color: field_border_color,
    padding: '0px',
  },
  scrollbar: {
    background: colors.dark[12],
    color: colors.dark[12],
  },
};
